<ul class="breadcrumbs tw-flex tw-flex-row"
  [dir]="dir$ | async">
  @for (url of urls; track url + $index; let last = $last; let first = $first) {
    <li
      [ngClass]="{'active': last}"
      class="tw-flex tw-flex-row tw-justify-center tw-items-center">
      <!-- disable link of last item -->
      @if (!first) {
        <mat-icon class="ms-breadcrumbs__navigate-divider"
          fontSet="fal"
        [fontIcon]="(dir$ | async) !== 'rtl' ? 'fa-angle-right' : 'fa-angle-left'"></mat-icon>
      }
      @if (!last && url === prefix) {
        <a role="button"
        >{{url}}</a>
      }
      @if (!last && url !== prefix && !(first && noIndexPage.includes(url))) {
        <a role="button"
          mat-button
          style='min-width: 0px;'
          class="ms-breadcrumbs__navigate-button"
        [routerLink]="url">{{friendlyName(url)}}</a>
      }
      @if (last || (first && noIndexPage.includes(url))) {
        <span class="ms-breadcrumbs__navigate-label-last"
        style="padding: 0px 4px">{{friendlyName(url)}}</span>
      }
      @if (last && url === prefix) {
        <span class="ms-breadcrumbs__navigate-label-last"
        >{{friendlyName('/')}}</span>
      }
    </li>
  }
</ul>


